'use client'

import { useEffect } from 'react'
import { consoleLogger } from '~/utils/console-logger'

/**
 * ConsoleLogger Component
 * Automatically starts console log capture when on app-test.taloflow.ai
 * Also suppresses Y.js "Invalid access" warnings globally
 */
export function ConsoleLogger() {
  useEffect(() => {
    // Start console logger if on app-test.taloflow.ai
    // The logger will automatically suppress Y.js "Invalid access" warnings
    consoleLogger.start()

    // Cleanup on unmount
    return () => {
      consoleLogger.stop()
    }
  }, [])

  return null // This component doesn't render anything
}

